import React from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { Divider } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const DISPLAY_ORDER = [
  "Basic",
  "Standard",
  "Premium",
  "Enterprise",
  "AWS Marketplace",
];

export const orderSubscriptions = (subscriptions = []) => {
  const ordered = DISPLAY_ORDER.map((name) =>
    subscriptions.find((sub) => sub.subscription === name)
  ).filter(Boolean);

  const extras = subscriptions.filter(
    (sub) => !DISPLAY_ORDER.includes(sub.subscription)
  );

  return [...ordered, ...extras];
};

const GlobalIaaC = (props) => {
  const cards = orderSubscriptions(props.iaac?.subscriptions);

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: {
          xs: "1fr",
          sm: "repeat(2, 1fr)",
          md: "repeat(3, 1fr)",
          lg: "repeat(5, 1fr)",
        },
        gap: 2,
        mt: 1,
      }}
    >
      {cards.map((card) => (
        <Paper
          key={card.subscription}
          elevation={0}
          sx={{
            p: 2.5,
            height: "100%",
            border: "1px solid #e5eaf2",
            borderRadius: "8px",
            boxShadow: "0 1px 4px rgba(25, 58, 111, 0.08)",
          }}
        >
          <Stack spacing={1.25}>
            <Typography
              variant="subtitle1"
              sx={{
                color: "#193a6f",
                fontWeight: 700,
                lineHeight: 1.3,
                minHeight: 40,
              }}
            >
              {card.subscription}
            </Typography>
            <Typography variant="h5" sx={{ fontWeight: 600, color: "#193a6f" }}>
              ${card.price}
            </Typography>
            <Typography variant="caption" sx={{ color: "#6b7280" }}>
              Billed Monthly
            </Typography>
            <Divider light />
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <CheckCircleIcon color="primary" fontSize="small" />
              <Typography variant="body2" sx={{ color: "#374151" }}>
                {card.limit === -1 ? "Unlimited" : `Upload Limit ${card.limit}`}
              </Typography>
            </Box>
          </Stack>
        </Paper>
      ))}
    </Box>
  );
};

export default GlobalIaaC;
